import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useProxyImport } from "./useProxyImport";
import { ProxyImportForm } from "./ProxyImportForm";
import { ProxyImportResults } from "./ProxyImportResults";
import type { JSX } from "react";

export function ProxyImport() {
  let proxyImport: JSX.Element;
  const { state, submitValidation, confirmSave, reset } = useProxyImport();
  const navigate = useNavigate();
  const goToProxies = () => {
    void navigate("/proxies");
  };
  if (state.kind === "form") {
    proxyImport = (
      <Box p={3} maxWidth={900}>
        <ProxyImportForm onSubmit={submitValidation} />
      </Box>
    );
  } else {
    if (state.kind === "validating") {
      proxyImport = (
      <Box p={3} maxWidth={900}>
        <ProxyImportResults
          entries={state.entries}
          summary={null}
          isValidating
          onConfirm={() => {}}
          onCancel={reset}
        />
      </Box>
    );
    } else {
      if (state.kind === "results") {
        proxyImport = (
      <Box p={3} maxWidth={900}>
        <ProxyImportResults
          entries={state.entries}
          summary={state.summary}
          isValidating={false}
          onConfirm={confirmSave}
          onCancel={reset}
        />
      </Box>
    );
      } else {
        if (state.kind === "saving") {
          proxyImport = (
      <Box p={3} maxWidth={900} display="flex" alignItems="center" gap={2}>
        <CircularProgress size={24} />
        <Typography>Сохранение…</Typography>
      </Box>
    );
        } else {
          if (state.kind === "success") {
            proxyImport = (
      <Box p={3} maxWidth={900}>
        <Alert severity="success" sx={{ mb: 2 }}>
          Импорт завершён: добавлено {state.result.addedCount},
          обновлено {state.result.updatedCount}.
        </Alert>
        <Box display="flex" gap={1}>
          <Button variant="contained" onClick={goToProxies}>
            К списку прокси
          </Button>
          <Button variant="outlined" onClick={reset}>
            Новый импорт
          </Button>
        </Box>
      </Box>
    );
          } else {
            proxyImport = (
    <Box p={3} maxWidth={900}>
      <Alert severity="error" sx={{ mb: 2 }}>
        {state.message}
      </Alert>
      <Box display="flex" gap={1}>
        <Button variant="contained" onClick={reset}>
          Попробовать снова
        </Button>
        <Button variant="outlined" onClick={goToProxies}>
          К списку прокси
        </Button>
      </Box>
    </Box>
  );
          }
        }
      }
    }
  }
  return proxyImport;
}
